<template>
  <footer id="TheFooter">
    <UIContainer class="TheFooter__container">
      <!-- CTA Section -->
      <div class="TheFooter__cta-container">
        <div class="TheFooter__cta-content">
          <h2 class="TheFooter__cta-title">
            Ready to take control of your ESG reporting?
          </h2>
          <p class="TheFooter__cta-description">
            Ingest real data, manage emission factors, engage suppliers, and
            file in iXBRL on one platform.
          </p>
        </div>

        <div class="TheFooter__cta-actions">
          <UIButton
            class="TheFooter__cta-action"
            size="xl"
            theme="light"
            buttonStyle="outlined"
            :to="{ name: 'Contact' }"
          >
            Book a demo
          </UIButton>
          <!--<UIButton class="TheFooter__cta-action" size="xl" theme="primary">
            Get started
          </UIButton>-->
        </div>
      </div>

      <TheFooterLinks class="TheFooter__links" />

      <!-- Socials -->
      <div class="TheFooter__bottom-row">
        <div class="TheFooter__copyright">
          © 2025 Sustainalyse. All rights reserved.
        </div>
        <div class="TheFooter__social">
          <!--<a href="#" aria-label="Mastodon">
            <UIIcon class="TheFooter__social-icon" name="slack" />
          </a>-->
          <a
            href="https://www.linkedin.com/company/sustainalyse"
            aria-label="LinkedIn"
          >
            <UIIcon class="TheFooter__social-icon" name="linkedin" />
          </a>
          <!--<a href="#" aria-label="Facebook">
            <UIIcon class="TheFooter__social-icon" name="facebook" />
          </a>-->
        </div>
      </div>
    </UIContainer>
  </footer>
</template>

<script setup lang="ts">
import UIButton from '../../buttons/UIButton.vue'
import UIContainer from '../../containers/UIContainer/UIContainer.vue'
import UIIcon from '../../icons/UIIcon.vue'
import TheFooterLinks from './components/TheFooterLinks.vue'
</script>

<style lang="scss" scoped>
#TheFooter {
  display: flex;
  justify-content: center;
  background-color: $color-lp-bg-brand-section;

  .TheFooter__container {
    padding: 2rem 1rem 2rem;
    @include md {
      padding: 4rem 1rem 3rem;
    }
  }

  .TheFooter__cta-container {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    gap: 1rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid $color-ui-brand-600;

    @include md {
      flex-direction: row;
      padding-bottom: 4rem;
    }
  }

  .TheFooter__cta-content {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    max-width: 768px;
  }

  .TheFooter__cta-title {
    color: $color-white;
    font-size: 1.875rem;
    line-height: 2.375rem;
    font-weight: 600;
  }

  .TheFooter__cta-description {
    @include font-size-20px();
    color: var(--Colors-Text-text-tertiary_on-brand);
  }

  .TheFooter__cta-actions {
    display: grid;
    grid-template-columns: auto auto;
    gap: 0.75rem;
    width: 100%;

    @include md {
      margin-left: auto;
      width: auto;
    }
  }

  .TheFooter__cta-action {
    width: 100%;

    @include md {
      width: fit-content;
    }
  }

  .TheFooter__links {
    margin-top: 2rem;

    @include md {
      margin-top: 4rem;
    }
  }

  .TheFooter__bottom-row {
    @include font-size-16px();
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $color-ui-brand-300;
  }

  .TheFooter__social {
    display: flex;
    gap: 1.5rem;
  }

  .TheFooter__social-icon {
    --size: 1.5rem;
  }
}
</style>
